import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import { useDispatch, useSelector } from 'react-redux';
import { treeActions } from '../../redux/slices/treeSlice';
import LabeledCheckbox from '../TemplateProperties/TPCheckbox';

const MappingButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMappingMode = useSelector(state => state.treeData.mappingStates.isMappingMode);
    const screen = useSelector(state => state.treeData.currentScreen);
    const templateHeader = useSelector(state => state.treeData.outbound.rightTree.tree.templateHeader);
    const dependency = templateHeader?.DEPENDENCIES || "";
    const dependencyArray = dependency.split("/");
    const templateName = dependencyArray?.[2] || "";
    const workflowName = dependencyArray?.[0] || "";
    const isLinkMode = useSelector(state => state.treeData.mappingStates.isLinkMode);
    const leftTreeNode = useSelector(state => state.treeData.outbound.leftTree.tree.body.selectedNode)
    const handleMapping = () => {
        dispatch(treeActions.setIsMappingMode(!isMappingMode));
    }
    
    const handleLinkMode = () => {
        dispatch(treeActions.setIsLinkMode(!isLinkMode));
    }

    useEffect(() => {
        dispatch(treeActions.setIsMappingMode(false));
        dispatch(treeActions.setIsLinkMode(false));
    },[leftTreeNode?.key]);

    return (
        (screen === "outbound" && templateHeader?.FILETYPE !== 'GraphQL') && <>


            {isMappingMode && <LabeledCheckbox
                label={t("BTN_LINK_MODE")}
                checked={isLinkMode}
                handleCheck={handleLinkMode}
                className="margin-right-4"
                disabled={templateName === "" || workflowName === ""}
            />}

            <Button
                size='small'
                variant="outlined"
                className="margin-right-4"
                onClick={handleMapping}
                disabled={templateName === "" || workflowName === ""}
            >
                <JoinInnerIcon fontSize="medium" className="margin-right-4" />
                {t("LBL_DATA_MAPPING_")}&nbsp;
            </Button>

        </>
    )
}

export default MappingButton
